"use client";

import { usePathname } from "next/navigation";
import { useGetFooterType } from "./hooks/useGetFooterType";

export const useFooterType = () => {
  const pathname = usePathname();
  const currentFooterType = useGetFooterType();

  const footerMap = new Map<string, typeof currentFooterType.default>([
    ["/payment", currentFooterType.inPayment],
    ["/filling", currentFooterType.inFilling],
  ]);

  const matched = Array.from(footerMap.keys()).find((path) => pathname.includes(path));

  const footerType = matched ? footerMap.get(matched)! : currentFooterType.default;

  return footerType;
};
